export default {
    namespaced: true,
    state: {
        // 用户信息
        info: {}
    },
    mutations: {
        setInfo(state, info) {
            state.info = info;
        }
    },
    actions: {
        /**
         * @description 设置用户数据
         * @param {Object} state vuex state
         * @param {*} info info
         */
        set(context, info) {
            return new Promise(async resolve => {
                // store 赋值
                context.commit('setInfo', info)
                // 持久化
                await context.dispatch('db/set', {
                    dbName: 'sys',
                    path: 'user.info',
                    value: info,
                    user: true
                }, {root: true});
                // end
                resolve()
            })
        },
        /**
         * @description 从数据库取用户数据
         * @param {Object} state vuex state
         */
        load(context) {
            return new Promise(async resolve => {
                // store 赋值
                const info = await context.dispatch('db/get', {
                    dbName: 'sys',
                    path: 'user.info',
                    defaultValue: {},
                    user: true
                }, {root: true});

                context.commit('setInfo', info);
                // end
                resolve()
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js